import {makeAutoObservable} from "mobx";

export class AuthTokenStorage {
    ACCESS_TOKEN = 'marketplace-sapore-access-token';
    constructor(storage) {
        this._storage = storage;
        this._token = this._storage.get(this.ACCESS_TOKEN) || null;
        makeAutoObservable(this);
    }

    removeToken() {
        this._token = undefined
        this._storage.remove(this.ACCESS_TOKEN)
    }

    addToken(token) {
        this._token = token
        this._storage.add(this.ACCESS_TOKEN, token);
    }

    getToken() {
        this._token = this._storage.get(this.ACCESS_TOKEN);
        return this._token
    }

    hasToken() {
        const token = this.getToken();
        return token !== null && token !== undefined;
    }
}
